import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { TitleChange } from '../services/title-change';

@Component({
  selector: 'app-not-found',
  imports: [],
  templateUrl: './not-found.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './not-found.scss',
})
export class NotFound {
  dynamicTitle = inject(TitleChange);

  constructor() {
    this.dynamicTitle.title(`Page Not Found`);
    this.dynamicTitle.description(`Sorry, just like Jesus, the page you are looking for doesn't exist.`);
  }
}
